import { Link } from "react-router-dom";
import { OVERVIEW_PATH } from "./blog/articleCards";

// Full-page message for a story that couldn't be shown, in the blog index's
// frame and type styles. The SPA can't change the HTTP status, so the page
// marks itself noindex to keep it out of search results.
export const StatusPage = ({ title, message }) => (
  <section className="blog-index status-page">
    <title>{title}</title>
    <meta name="robots" content="noindex" />
    <header className="blog-index-header">
      <h1>
        <span className="blog-index-subheading">{title}</span>
      </h1>
    </header>
    <p className="status-page-message">{message}</p>
    <Link to={OVERVIEW_PATH} className="status-page-link">
      Back to the blog
    </Link>
  </section>
);

export const NotFoundPage = () => (
  <StatusPage
    title="Post not found"
    message="We couldn't find the page you were looking for. It may have moved, or the link may be mistyped."
  />
);

export const LoadErrorPage = () => (
  <StatusPage
    title="Something went wrong"
    message="We couldn't load this page right now. Please try again in a moment."
  />
);
